import React from 'react';
//import { ReactPDF, PDFViewer } from '@react-pdf/renderer';
//import PDFViewer from 'pdf-viewer-reactjs'
import PdfCompany from '../../utils/pdf/companyScheduleJSON';
import PdfAllCompany from '../../utils/pdf/companyScheduleJSON_ALL';
import PdfAllInvestors from '../../utils/pdf/investorScheduleJSON_ALL';
import PdfInvestor from '../../utils/pdf/investorScheduleJSON';
import GetEvent from '../../services/getEvent';
import GetCompany from '../../services/getCompany';
import GetCompanies from '../../services/getCompanies';
import GetInvestors from '../../services/getInvestors';
import GetMeetings from '../../services/getMeetings';
import GetBreaks from '../../services/getBreaks';
import Cookies from 'universal-cookie';
import getInvestor from '../../services/getInvestor';
import WaitDialog from '../../widgets/WaitDialog';
import getAnalysts from '../../services/getAnalysts';

export default class PdfPage extends React.Component {

  constructor (){
    super();

    this.pdfUrl = undefined;
  }


  async componentDidMount(){
    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });

    const startDate = cookies.get('pdfStartDate', { path: '/' });
    const endDate = cookies.get('pdfEndDate', { path: '/' });

    this.event = await GetEvent(uname, token, currentEventId);

    this.scheduleType = cookies.get('scheduleType');
    this.scheduleSubject = cookies.get('scheduleSubject');
    this.brokerId = cookies.get('brokerId');

    this.companies = await GetCompanies(uname, token, currentEventId);
    this.investors = await GetInvestors(uname, token, currentEventId);
    this.analysts = await getAnalysts(uname, token, currentEventId);
    this.company = await GetCompany(uname, token, currentEventId, this.scheduleSubject);
    this.investor = await getInvestor(uname, token, currentEventId, this.scheduleSubject);
    this.meetings = await GetMeetings(uname, token, currentEventId);
    this.breaks = await GetBreaks(uname, token, currentEventId);

    this.setState({waitDialogVisible: true});

    if (this.scheduleType == 'company'){
      this.pdfUrl = await PdfCompany.getAddress(this.event, this.company, this.breaks, this.meetings, '');
//      element = <PdfCompany key={Math.random()} event={this.event} company={this.company} breaks={this.breaks} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
//      this.fileName = this.company.name + '.pdf';
    } else if (this.scheduleType == 'investor'){
      this.pdfUrl = await PdfInvestor.getAddress(this.event, this.investor, this.breaks, this.meetings, '');
     // element = <PdfInvestor key={Math.random()} event={this.event} investor={this.investor} breaks={this.breaks} meetings={this.meetings} onRender={(data) => this.onRender(data)} />;
     // this.fileName = this.investor.company + ' - ' + this.investor.name + '.pdf';
    } else if (this.scheduleType == 'allCompanies'){
      var json = cookies.get('checksList', { path: '/' });
      var checksList = json.list;
      if (checksList.length > 0)
        this.companies = this.companies.filter((elem) => checksList.indexOf(elem.id) != -1);
      
      if (this.brokerId != "")
        this.companies = this.companies.filter((elem) => elem.broker_id.indexOf(this.brokerId) != -1);

      this.pdfUrl = await PdfAllCompany.getAddress(this.event, this.companies, this.breaks, this.meetings, this.updateWaitDialog.bind(this), startDate, endDate);

     // element = <PdfAllCompany key={Math.random()} event={this.event} companies={this.companies} breaks={this.breaks} meetings={this.meetings} />;
     // this.fileName = 'companies.pdf';
    } else if (this.scheduleType == 'allInvestors'){

      var json = cookies.get('checksList', { path: '/' });
      var checksList = json.list;
      if (checksList.length > 0)
        this.investors = this.investors.filter((elem) => checksList.indexOf(elem.id) != -1);

        if (this.brokerId != "")
        this.investors = this.investors.filter((elem) => elem.brokerId.indexOf(this.brokerId) != -1);

      this.pdfUrl = await PdfAllInvestors.getAddress(this.event, this.investors, this.breaks, this.meetings, this.updateWaitDialog.bind(this), startDate, endDate);
    }
    else if (this.scheduleType == 'allAnalysts'){

      var json = cookies.get('checksList', { path: '/' });
      var checksList = json.list;
      if (checksList.length > 0)
        this.analysts = this.analysts.filter((elem) => checksList.indexOf(elem.id) != -1);

      this.pdfUrl = await PdfAllInvestors.getAddress(this.event, this.analysts, this.breaks, this.meetings, this.updateWaitDialog.bind(this), startDate, endDate);
      
      if(this.pdfUrl.toString().includes('undefined')) {
        alert("Nothing found. Please check that at least one Analyst has a meeting in the selected time interval.");
      }
      
    }
    this.setState({waitDialogVisible: false});

  }

  updateWaitDialog(str){
    this.setState({waitDialogVisible: true, index: str});

  }


  render(){

    this.fileName = '';
    this.dirName = '';

    if (this.scheduleType == undefined) return <div />;

    return (
      <div style={{width: '100%', height: '100%'}}>
        <object width="100%" height="95%" data={this.pdfUrl} type="application/pdf">   </object>
        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
      </div>
    );
  }

}

